import { Component } from '@angular/core';
import { AuthUserService } from '../../services/auth-user.service';
import { MyFormsListComponent } from '../../components/my-forms-list/my-forms-list.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    MyFormsListComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

  constructor(public authUserService: AuthUserService) {
  }

  get userDisplayName() : String { return this.authUserService.displayName }
  get showReviewForms() : Boolean { return this.authUserService.canReviewForms }
  get enableCreateForm() : Boolean { return this.authUserService.canUpdateOwnForms }
}
